<template>
  <div>
    <table border="1" class="table" style="border: #ebeef4;">
      <el-checkbox-group v-model="checkedItems" @change="handleCheckedChange">
      <tr style="background:#F3E8E3">
        <th v-if="batch_edit_visible" style="width: 5%;">
          <el-button style="font-size: 12px;background-color: #F3E8E3; border: 0px;" type="text" @click="handleCheckAllChange">{{ buttonText }}</el-button>
        </th>
        <th>编号</th>
        <th>项目</th>
        <th>记账月份</th>
        <th>实际消耗月份</th>
        <th>达人账号</th>
        <th>投放周期</th>
        <th>下单金额</th>
        <th>服务费比例(小数)</th>
        <th>返点金额</th>
      </tr>
      <template v-for="(items,ind) in dataInfo.order.list">
        <tr v-for="(item,index) in items.row" :key="ind+'tr'+index+'row'">
          <td v-if="batch_edit_visible"><el-checkbox :label="ind+'-'+index"><br></el-checkbox></td>
          <td>{{index+1}}</td>
          <td>{{item.project_name_second}}</td>
          <td>{{item.month}}</td>
          <td>{{item.order_original_month}}</td>
          <td>{{item.internet_celebrity_name}}</td>
          <td>{{item.launch_start_date}}</td>
          <td style="text-align: right;">
            <span v-if="dataInfo.account.verify_status != 0 && dataInfo.account.verify_status != 3 &&dataInfo.account.verify_status != 5 && statement_id">{{$formatNum(item.final_amount)}}</span>
            <el-input v-model="item.final_amount" v-else @input="(val)=>{item.final_amount=item.final_amount.replace(/[^\d|.]/g,'');changeMcnInput(item,ind)}" size='mini' style="width:100%;hight:100%"></el-input>
          </td>
          <td>
            {{item.percentage_of_service_charge}}
          </td>
          <td style="text-align: right;">
            {{$formatNum(item.return_point_amount)}}
          </td>
        </tr>
        <tr style="background:#f4f7fa" :key="ind+'tr1'">
          <td v-if="batch_edit_visible"></td>
          <td colspan='6'>{{items.sort_month}}小计</td>
          <td style="text-align: right;">{{$formatNum(items.final_amount)}}</td>
          <td></td>
          <td style="text-align: right;">{{$formatNum(items.return_point_amount)}}</td>
        </tr>
        <tr v-if="ind + 1 == dataInfo.order.list.length" :key="ind+'tr2'">
          <td v-if="batch_edit_visible"></td>
          <td colspan='6' style="color:#393d64;font-weight:500;">总金额</td>
          <td colspan='3' style="text-align: right;">{{$formatNum(dataInfo.order.total.return_point_amount)}}</td>
        </tr>
      </template>
    </el-checkbox-group>
    </table>

    <el-dialog title="编辑下单金额" :visible.sync="dialogVisible" width="300px" :close-on-click-modal='false' center>
      <div class="dialogBox" v-loading='loading'>
        <div class="dialogitem form-item bMr-10">{{ '当前已选择'+this.checkedItems.length+'条订单数据' }}</div>
        <div class="dialogitem form-item">
          <label style="font-size:14px">下单金额：</label>
          <el-input size="mini" style="width: 60%;" :min=0 placeholder="请输入下单金额" v-model="batch_final_amount" @input="(val)=>{batch_final_amount=batch_final_amount.replace(/[^\d|.]/g,'');}"/>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible=false;" size="mini">取 消</el-button>
        <el-button type="primary" @click="handleMultipleEdit" size="mini">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ['dataInfo', 'statement_id'],
  data () {
    return {
      loading: false,
      type: '',
      add_date: '',
      fileList: [],
      uploadFile: [],
      fileData: {
        admin_id: JSON.parse(this.$cookie.getCookie('userInfo')).admin_id,
        ttl: JSON.parse(this.$cookie.getCookie('userInfo')).ttl,
        sign: JSON.parse(this.$cookie.getCookie('userInfo')).sign
      },
      fileType: '',
      csvTh: [],
      csvData: [],
      lookFlag: false,
      file_url: '',
      batch_edit_visible: false,// 是否显示批量编辑按钮以及多选框
      checkedItems: [],// 已选择的订单
      checkedOptions: [],// 全部订单标识
      buttonText: "全选",
      dialogVisible: false,// 下单金额编辑弹窗显示隐藏
      batch_final_amount: 0,// 批量编辑的下单金额
    }
  },
  created () {
    // 遍历列表，初始化所有下标索引
    this.dataInfo.order.list.forEach((items,ind) => {
      items.row.forEach((item, index) => {
        this.checkedOptions.push(ind+'-'+index)
      })
    })  
    
    // 判定是否展示批量编辑功能
    if(this.dataInfo.account && (!this.statement_id || this.dataInfo.account.verify_status == 0 || this.dataInfo.account.verify_status == 3 || this.dataInfo.account.verify_status == 5)) {
      this.batch_edit_visible = true
    }
  },
  methods: {
    changeMcnInput (data, index) {
      var dan_final_amount = data.final_amount ? data.final_amount : 0;//下单金额
      //折扣金额 = 下单金额 * 服务费比例
      data.percentage_of_service_charge = Number(dan_final_amount) == 0 ? '' : (parseFloat((Number(data.return_point_amount) / Number(dan_final_amount)).toFixed(4)));
      //小记
      var final_amount = '', return_point_amount = '';
      this.dataInfo.order.list[index].row.forEach((item) => {
        if (item.final_amount) {
          final_amount = Number(final_amount) + Number(item.final_amount)
        }
        if (item.return_point_amount) {
          return_point_amount = Number(return_point_amount) + Number(item.return_point_amount)
        }
      });
      this.dataInfo.order.list[index].final_amount = parseFloat(Number(final_amount))
      this.dataInfo.order.list[index].return_point_amount = parseFloat(Number(return_point_amount))
    },
    // 全选，全不选
    handleCheckAllChange () {   
      let checkCount = this.checkedItems.length
      let allCount = this.checkedOptions.length
      if(checkCount < allCount) {
        this.checkedItems = this.checkedOptions
        this.buttonText = '全不选'
      } else {
        this.checkedItems = []
        this.buttonText = '全选'
      }
    },
    handleCheckedChange() {
      let checkCount = this.checkedItems.length
      let allCount = this.checkedOptions.length
      if(checkCount < allCount) {
        this.buttonText = '全选'
      } else {
        this.buttonText = '全不选'
      }
    },
    openBatchEditDialog() {
      this.dialogVisible = true
    },
    // 批量编辑下单金额
    handleMultipleEdit() {
      // 验证
      if(this.checkedItems.length == 0) {
        this.$message({
          message: '未选择订单',
          type: 'warning'
        })
        return
      }
      if(Number(this.batch_final_amount) < 0) {
        this.$message({
          message: '下单金额不得小于0',
          type: 'warning'
        })
        return
      }

      // 确认后循环调用修改方法 
      this.$confirm('确定修改订单金额吗？', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        // 循环订单列表，依次判断订单是否修改
        this.dataInfo.order.list.forEach((items,ind) => {
          items.row.forEach((item, index) => {
            let tempKey = ind+'-'+index
            if(this.checkedItems.includes(tempKey)) {
              item.final_amount = this.batch_final_amount
              this.changeMcnInput(item, ind)
            }
          })
        })  
        this.loading = false
        this.checkedItems = []
        this.batch_final_amount = 0
        this.buttonText = '全选'
        // 弹窗关闭
        this.dialogVisible = false
        this.$message({
          message: '编辑成功',
          type: 'success'
        })
      })
    },
  }
}
</script>
<style lang="scss" scoped>
@import "./statementDetail.scss";
</style>
<style lang="scss">
.statementToast {
  .el-form-item__content {
    font-size: 12px !important;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0 !important;
  }
  .table .el-input__inner {
    padding: 0 !important;
    text-align: center !important;
  }
  .bMr-10 {
    margin-bottom: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/newBilling/statementTemplate/mcnStatementDetail.vue